import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { ModelService } from "../../Services/model.service";
import { TranslateService } from '@ngx-translate/core';
import { CatalogDataQuality } from '../../Model/validation/CatalogDataQuality';
import { CatalogDataQualityTable } from '../../Model/validation/CatalogDataQualityTable';
import { Message } from "../../Model/System/Message";
import { UserManagementService } from "../../Services/userManagment.service";
import { ExportParameter } from "../../Model/exportParameter/ExportParameter";
import { Catalog } from "../../Model/Catalog/Catalog";

@Component({
  selector: "dataQualityStatistic",
  templateUrl: "dataQualityStatistic.component.html",
  styleUrls: ["dataQualityStatistic.component.css"],
  standalone: false
})
export class DataQualityStatisticComponent implements OnChanges {
  @Input() catalogDataQuality: CatalogDataQuality;

  selectedTable: CatalogDataQualityTable = null;

  txtExportAlsJob: string;

  constructor(public modelService: ModelService, public translate: TranslateService, public userManagement: UserManagementService) {
    this.txtExportAlsJob = this.translate.instant("Der Export wird als Job ausgeführt");
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.catalogDataQuality?.catalogDataQualityTable?.length) {
      this.selectedTable = this.catalogDataQuality.catalogDataQualityTable[0];
    } else {
      this.selectedTable = null;
    }
  }

  exportDetails() {
    var result = new ExportParameter();
    result.catalogId = this.modelService.catalogService.selectedCatalogId;
    result.customerId = this.modelService.loginService.currentUser.customerId;
    result.format = "Qualitydetails";

    this.modelService.catalogService.createExportJob(result).subscribe(
      () => {
        this.modelService.systemService.notify(new Message(this.txtExportAlsJob));
      });
  }

  canView(name: string): boolean {
    return this.userManagement.canView(name);
  }

  readOnlyUser(name: string, catalog: Catalog = this.modelService.catalogService.catalog): boolean {
    return !this.userManagement.canEdit(name, catalog);
  }
}
